import { handleActions } from 'redux-actions';

import * as types from './actionTypes';

const initialState = [];

let errorId = 0;

const reducerMap = {
	[types.REPORT_ERROR]: (state, { payload }) => {
		const { error, url } = payload;
		errorId++;

		return [
			...state,
			{
				...error,
				url,
				screenId: window.screenId,
				id: errorId,
			},
		];
	},
	[types.CLEAR_ERROR]: (state, { payload }) => {
		return state.filter((e) => e.id !== payload.errorId);
	},
	[types.CLEAR_ALL_ERRORS]: () => initialState,
};

export default handleActions(reducerMap, initialState);
